<template>
  <div>
    <permission-template-list></permission-template-list>
  </div>
</template>

<script>

export default {
}
</script>


